import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { TextField, Checkbox, FormControlLabel, Button, Grid, Typography, Paper,IconButton,InputLabel,Select,MenuItem ,FormGroup} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useAuth from './useAuth.js';
import { useNotification } from "../../components/NotificationContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
const ProductDiscountAdd = () => {
    useAuth();
    const showNotification = useNotification();
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [categories, setCategories] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [productData, setProductData] = useState({
        name: "",
        category: "",
        price: "",
      });
      const [discountData, setDiscountData] = useState({
        discountedPrice: '',
        startDate: '',
        endDate: ''
      });
      
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
  
        const [productRes, categoryRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/product`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${process.env.REACT_APP_API_URL}/categories`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);
  
        const products = productRes.data;
        setProducts(products);
        setCategories(categoryRes.data);
      } catch (error) {
        showNotification("Veriler getirilemedi!", "error");
      }
    };
  
    fetchData();
  }, []);
  useEffect(() => {
    if (selectedSubCategory) {
      const filtered = products.filter(
        (p) => Number(p.category) === selectedSubCategory
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts([]);
    }
  }, [selectedSubCategory, products]);

    const handleBackClick = () => {
        navigate(-1);
      };

      const handleProductSelect = (product) => {
        setSelectedProduct(product);
        setProductData({
          name: product.name,
          price: product.price,
        });
      };
      const handleChange = (e) => {
        const { name, value } = e.target;
        setProductData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
      const handleDiscountChange = (e) => {
        const { name, value } = e.target;
        setDiscountData((prev) => ({
          ...prev,
          [name]: value
        }));
      };
      const handleSubmitDiscount = async () => {
        if (!selectedProduct) {
          showNotification("Lütfen bir ürün seçin", "warning");
          return;
        }
      
        const token = localStorage.getItem('token');
        try {
          await axios.post(`${process.env.REACT_APP_API_URL}/product/discounts`, {
            productId: selectedProduct.id,
            discountedPrice: discountData.discountedPrice,
            startDate: discountData.startDate,
            endDate: discountData.endDate
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });
      
          showNotification("İndirim başarıyla kaydedildi!", "success");
      
          // Formu sıfırla
          setDiscountData({
            discountedPrice: "",
            startDate: "",
            endDate: ""
          });
          setSelectedProduct(null); // Eğer ürün de sıfırlansın isteniyorsa
        } catch (error) {
          const errorMessage = error.response?.data?.message || "İndirim kaydedilemedi!";
          showNotification(errorMessage, "error");
        }
      };
      
      
      return (
        <Grid container justifyContent="center" alignItems="center" >
          <Grid size={{ xs: 12, sm: 10,md:10 }}>
            <Paper elevation={5} style={{ padding: '30px', borderRadius: '15px', backgroundColor: '#ffffff' }}>
            <IconButton onClick={handleBackClick} style={{ marginRight: '10px' }}>
            <ArrowBackIcon />
          </IconButton>
              <Typography variant="h4" gutterBottom align="center" style={{ fontWeight: 600, color: '#3f51b5' }}>
                Yeni ürün indirimi ekle
              </Typography>
              <TextField
  select
  label="Ana Kategori Seç"
  value={selectedCategory?.id || ''}
  onChange={(e) => {
    const selected = categories.find(cat => cat.id === Number(e.target.value));
    setSelectedCategory(selected);
    setSelectedSubCategory(null);
    setSelectedProduct(null);
  }}
  fullWidth
>
  {categories.map((cat) => (
    <MenuItem key={cat.id} value={cat.id}>
      {cat.name}
    </MenuItem>
  ))}
</TextField>

{/* Alt Kategori Seçimi */}
{selectedCategory && (
  <TextField
    select
    label="Alt Kategori Seç"
    value={selectedSubCategory || ''}
    onChange={(e) => {
      setSelectedSubCategory(Number(e.target.value));
      setSelectedProduct(null);
    }}
    fullWidth
    sx={{ mt: 2 }}
  >
    {selectedCategory.subCategories.map((sub) => (
      <MenuItem key={sub.id} value={sub.id}>
        {sub.name}
      </MenuItem>
    ))}
  </TextField>
)}

{/* Ürün Seçimi */}
{selectedSubCategory && (
  <TextField
    select
    label="Ürün Seç"
    value={selectedProduct?.id || ''}
    onChange={(e) => {
      const prod = filteredProducts.find((p) => p.id === Number(e.target.value));
      handleProductSelect(prod);
    }}
    fullWidth
    sx={{ mt: 2 }}
  >
    {filteredProducts.map((product) => (
      <MenuItem key={product.id} value={product.id}>
          <img 
            src={`${process.env.REACT_APP_BASE_URL}${product.photo_url}`}
            alt={product.name}
            style={{ width: '40px', height: '40px', marginRight: '10px', borderRadius: '4px' }}
          />
          {product.name}
        </MenuItem>
    ))}
  </TextField>
)}
<Typography variant="h6" sx={{ mt: 2, color: "text.secondary" }}>
  Normal Ücret: {productData.price} TL
</Typography>
<TextField
  fullWidth
  label="İndirimli Ücret"
  name="discountedPrice"
  value={discountData.discountedPrice}
  onChange={handleDiscountChange}
  margin="normal"
  variant="outlined"
/>

<TextField
  fullWidth
  label="İndirim Başlangıç Tarihi"
  name="startDate"
  type="date"
  value={discountData.startDate}
  onChange={handleDiscountChange}
  margin="normal"
  InputLabelProps={{ shrink: true }}
/>

<TextField
  fullWidth
  label="İndirim Bitiş Tarihi"
  name="endDate"
  type="date"
  value={discountData.endDate}
  onChange={handleDiscountChange}
  margin="normal"
  InputLabelProps={{ shrink: true }}
/>

<Button
  variant="contained"
  color="primary"
  fullWidth
  sx={{ mt: 2 }}
  onClick={handleSubmitDiscount}
>
  İndirimi Kaydet
</Button>

              </Paper>
      </Grid>
    </Grid>
  );
};

export default ProductDiscountAdd;
